import React from 'react';
import { Radio } from 'react-feather';
import classnames from 'classnames';

import StrapiButton from '../StrapiLink/StrapiButton';
import { LinkComponentFragment, Maybe, WebsiteLocaleFragment } from '../../../graphql.schema';

import * as styles from './top-bar-cta.module.scss';

type Props = {
  cta?: Maybe<LinkComponentFragment>;
  websiteLocale?: Maybe<WebsiteLocaleFragment>;
};
const TopBarCTA = (props: Props) => {
  return (
    <StrapiButton websiteLocale={props?.websiteLocale ?? undefined} className={classnames(styles.root)} {...props.cta} hideIcon={true}>
      <span className={styles.text}>{props.cta.title}</span>
    </StrapiButton>
  );
};

export default TopBarCTA;
